import React from 'react';
import '../styles/hero.scss';
import heroLockupD from '../assets/heroLockupD.svg';
import heroLockupM from '../assets/heroLockupM.svg';

const Hero = ({ screenWidth }) => {
  return (
    <div className="hero">
      <div className="hero__lockup">
        <img src={screenWidth >= 1000 ? heroLockupD : heroLockupM} alt="text" />
      </div>
      <div className="hero__introText">
        <h5>Space is an endless expanse of vast and boundless possibility…</h5>
        <h5>
          It’s a place where an open door offers the opportunity to literally reach for the stars.
        </h5>
        <h5>
          Predicted to be a $1 trillion economy by 2040, the space industry cannot realize its full
          potential without inviting more women and other traditionally excluded groups to
          participate.
        </h5>
        <h5 className="bold">It’s time to offer access for all.</h5>
      </div>
    </div>
  );
};

export default Hero;
